"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LayoutPagingTable = _interopRequireDefault(require("01_core/components/layout/LayoutPagingTable"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _SortUpdate = _interopRequireDefault(require("01_core/components/select/SortUpdate"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _areaOrderingActions = require("../areaOrderingActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 地域表示順設定検索結果コンポーネント
 */
const AreaOrderingSearchResult = function (props) {
  const {
    intl,
    searchResult,
    paging,
    changeCurrentPage,
    changeViewNum,
    scrollTop,
    onScroll,
    search,
    onDetailClick,
    onSortUpdate
  } = props;
  const createRow = data => {
    // 並び替え用の配列を作成する
    let sortItems = [];
    data.areaSortOrders.forEach(function (areaSortOrderInfo) {
      let addItem = {
        value: areaSortOrderInfo.sortOrderingKey,
        //並べ替え対象の値
        displayName: areaSortOrderInfo.areaNm // 並べ替え対象の表示名
      };
      sortItems.push(addItem);
    });
    const actions = [data.areaCount >= 1 ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      action: "detail",
      onClick: onDetailClick(data.kaishaCd)
    }) : '', data.areaCount >= 2 ? /*#__PURE__*/_react.default.createElement(_SortUpdate.default, {
      items: sortItems,
      onChange: onSortUpdate,
      noUpdate: false,
      isDispListIcon: true
    }) : ''];
    const kaishaNm = _stringUtil.default.emptyToHyphen(data.kaishaNm);
    const areaCount = data.areaCount;
    return {
      actions,
      kaishaNm,
      areaCount
    };
  };

  // 検索結果ヘッダ
  let listButtonLabel = [intl.formatMessage({
    id: _labelConsts.LABEL.CORE_DETAIL
  }), intl.formatMessage({
    id: _labelConsts.LABEL.CORE_UPDATE
  })];
  const columns = [{
    dataKey: 'actions',
    label: listButtonLabel,
    direction: 'row'
  }, {
    dataKey: 'kaishaNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_COMPANY_NAME
    }),
    width: 300
  }, {
    dataKey: 'areaCount',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.MASTERDATA_AREA_COUNT
    }),
    width: 300
  }];
  return /*#__PURE__*/_react.default.createElement(_LayoutPagingTable.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SEARCH_RESULT_LIST
    }),
    rowData: searchResult,
    createRow,
    columns,
    paging,
    changeCurrentPage,
    changeViewNum,
    scrollTop,
    onScroll,
    reload: search,
    putTypography: true
  });
};
const mapStateToProps = state => {
  return {
    searchResult: state.areaOrdering.searchResult,
    paging: state.areaOrdering.paging,
    scrollTop: state.areaOrdering.scrollTop,
    search: state.areaOrdering.search
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeCurrentPage: currentPage => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.CHANGE_PAGE](currentPage)),
    changeViewNum: viewNum => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.CHANGE_VIEW_NUM](viewNum)),
    onScroll: scrollTop => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.CHANGE_SCROLL_TOP](scrollTop))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(AreaOrderingSearchResult));